export default {
  'app.pwa.offline': 'Sei offline ora',
  'app.pwa.serviceworker.updated': 'Nuovo contenuto disponibile',
  'app.pwa.serviceworker.updated.hint':
    'Premi il pulsante "Aggiorna" per ricaricare la pagina corrente',
  'app.pwa.serviceworker.updated.ok': 'Aggiorna',
};
